export default "/assets/images/social-facebook.svg";